function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import PopOver from '../../components/popover';
import { MDCFormCheckbox } from "../../../jsx/components/mdc-components";
import { ButtonIcon } from "../../ui";
import publishEvent from "../../functions/publish-event";
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "columnDisplayCount", () => {
      var count = 0;
      var columnDisplay = this.state.columnDisplay;
      for (const [key, value] of Object.entries(columnDisplay)) {
        if (value) {
          count += 1;
        }
      }
      return count;
    });
    _defineProperty(this, "onCheckedChange", event => {
      var columnDisplay = this.state.columnDisplay;
      var target = event.target;
      var checked = target.checked;
      var id = target.id;
      var prop = id.replace('ck-display-', '');
      var count = this.columnDisplayCount();
      console.log(count);
      console.log(columnDisplay);
      if (checked) {
        columnDisplay[prop] = checked;
        this.setState({
          columnDisplay
        });
      } else if (!checked && count > 1) {
        columnDisplay[prop] = checked;
        this.setState({
          columnDisplay
        });
      } else {
        publishEvent('send-alert', {
          message: 'Minimum one column to display required.'
        });
        columnDisplay[prop] = true;
        this.setState({
          columnDisplay
        });
      }
    });
    _defineProperty(this, "onFilterClick", event => {
      this.popover.hide();
      this.props.onFilterRequest(this.state.columnDisplay);
    });
    _defineProperty(this, "onClearClick", event => {
      var clearState = this.initState();
      this.setState(clearState);
      var route = '/Contacts';
      //this.popover.hide();
      this.props.onFilterRequest(route);
    });
    this.state = this.initState();
  }
  componentDidMount() {}
  initState() {
    return {
      columnDisplay: this.props.columnDisplay
    };
  }
  get columnNodes() {
    var items = this.props.columns;
    var columnDisplay = this.state.columnDisplay;
    var index = 0;
    var nodes = items.map(item => {
      index += 1;
      var checked = columnDisplay[item.prop];
      return /*#__PURE__*/React.createElement(MDCFormCheckbox, {
        key: index,
        checked: checked,
        label: item.title,
        id: "ck-display-" + item.prop,
        name: "ck-display",
        onCheckedChange: this.onCheckedChange
      });
    });
    return nodes;
  }
  render() {
    var cls = 'column-display';
    var nodes = this.columnNodes;
    var length = nodes.length;
    if (length > 14) {
      cls += ' long';
    }
    return /*#__PURE__*/React.createElement(PopOver, {
      color: "secondary",
      cls: "filter-popover mini",
      label: "Filter",
      icon: "filter_alt",
      ref: ref => this.popover = ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "filter-header"
    }, "Display Columns"), /*#__PURE__*/React.createElement("div", {
      className: "contact-filter-container flex-around"
    }, /*#__PURE__*/React.createElement("div", {
      className: cls
    }, nodes), /*#__PURE__*/React.createElement("div", {
      className: "right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filter-buttons"
    }, /*#__PURE__*/React.createElement(ButtonIcon, {
      label: "filter",
      icon: "filter_alt",
      onClick: this.onFilterClick
    })))));
  }
}